import { get, isEmpty } from 'lodash';
import {
  IModalDialogOptions,
  IWidgetData,
  WIDGET_COMPONENT,
} from '../../../shared/types';
import { WIDGET_FAMILY } from '@config/global-constants';
import { I18n } from '@app/i18n/strings-keys';

export const gridSelectModalOptions = (
  data,
  i18nService,
): IModalDialogOptions => {
  return {
    modalClass: 'modal-md',
    title: I18n.Common.AddItems,
    buttons: [
      {
        disabled: (formValue): boolean => {
          return formValue ? isEmpty(get(formValue, 'items', [])) : false;
        },
      },
    ],
    value: {
      items: [],
    },
    schema: {
      properties: {
        tips: {
          type: 'string',
        },
        items: {
          title: null,
          type: 'array',
          minItems: 1,
          required: true,
        },
      },
    },
    formRules: {
      fields: {
        tips: {
          show: false,
        },
        items: {
          widget: WIDGET_COMPONENT.grid_list,
          widgetFamily: WIDGET_FAMILY.XUX,
          class: 'grid-select-modal',
          widgetData: {
            canRemove: false,
            showSearch: true,
            canEdit: false,
            orderControls: false,
            disableColumnSelector: true,
            returnFullData: true,
            valueField: 'uniq_id',
            userGridOptions: {
              enableServerSideFilter: false,
              overlayNoRowsTemplate: i18nService.instant(
                I18n.Common.NoRowsToShow,
              ),
            },
            hideActionPanel: false,
            columns: [
              {
                defaultView: true,
                path: 'name',
                title: I18n.Forms.GridForm.GridItems,
                filterParams: {
                  quickFilter: true,
                },
              },
            ],
            gridHeight: '400px',
            selectOptions: data,
          },
        },
      },
    },
  };
};

export const defaultWidgetData: IWidgetData = {
  canRemove: false,
  valueField: 'value',
  multiselect: false,
  disableColumnSelector: true,
  showSearch: true,
  canEdit: false,
  inlineRemove: true,
  userGridOptions: {
    deltaRowDataMode: true,
    domLayout: 'normal',
  },
  columns: [
    {
      title: I18n.Common.Text,
      path: 'value',
      defaultView: true,
      sortable: false,
    },
  ],
};
